import { StoreType } from 'features/my-store/types/StoreType';
import { NotificationListItemType } from 'features/notification/types/NotificationType';

/**
 * 指定した店舗IDでお知らせをフィルタする
 *
 * @param notifications お知らせ
 * @param storeIds 店舗IDの配列
 * @returns 対象のお知らせ
 */
export const filterByStoreIds = (
  notifications: NotificationListItemType[],
  storeIds: number[]
): NotificationListItemType[] => {
  return notifications.filter(
    (notification) =>
      !!notification.stores?.some((store) => storeIds.includes(store.id))
  );
};

/**
 * 指定した店舗でお知らせをフィルタする
 *
 * @param notifications お知らせ
 * @param stores 店舗の配列
 * @returns 対象のお知らせ
 */
export const filterByStores = (
  notifications: NotificationListItemType[],
  stores: StoreType[]
): NotificationListItemType[] => {
  const storeIds = stores.map((store) => store.id);
  return filterByStoreIds(notifications, storeIds);
};
